import {WicketAgreement} from '../wicket-agreement';
import {WicketLocaleOverride} from '../wicket-locale-override';

export interface WicketAgreementSection {
  id: string;
  title: string;
  active_agreements: WicketAgreement[];
  footer: string | null;
  grantAll?: boolean;
  language_code: string;
  ord: number;
  locale_override: WicketLocaleOverride<'title' | 'footer', string>[];
  is_displayed_by_admin?: boolean;
  is_displayed_by_user?: boolean;
}
